export default [
   { name: "date", label: "Data", type: "date" as const },
   { name: "hours", label: "Liczba godzin", type: "time" as const }
]